<div fxLayout="column" fxFlex fusePerfectScrollbar>
    <mat-list class="date" cdkFocusRegionStart>
        <h3 matSubheader cdkFocusInit>
            <span>Oggi</span>
        </h3>

        <div class="secondary-text mat-display-1 mb-0 p-16">
            <div class="mb-12">
                {{ date | date: 'EEEE' }}
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <span> {{ date | date: 'd' }}</span>
                <span class="mat-subheading-1">th</span>
                <span> {{ date | date: 'MMMM' }}</span>
            </div>
        </div>
    </mat-list>

    <mat-divider cdkFocusRegionEnd></mat-divider>
    <!-- 
    <mat-list>
        <h3 matSubheader>
            <span>Notes</span>
        </h3>

        <mat-list-item *ngFor="let note of notes">
            <h3 matLine>{{ note.title }}</h3>
            <p matLine class="secondary-text">{{ note.detail }}</p>
        </mat-list-item>
    </mat-list>

    <mat-divider></mat-divider> -->
</div>
